<template>
	<component
		:is="textData.tag?textData.tag:tag" class="boardComponentTextField"
		:id="textData.id"
		:class="[{bold:bold}, {title:title}, textData.class, size]"
		:style="textData.style">
		<span class="txtCont">{{ textData.text }}</span>
		<span class="handcursor" @click="openModal">
			<b-icon icon="pencil" size="is-small" type="is-gray"></b-icon>
		</span>
	</component>
</template>

<script>
import { Chrome } from 'vue-color'
import tinycolor from 'tinycolor2'
import TextContentEditModal from './TextContentEditModal'
export default {
	name: 'TextFieldEditor',
	components: {
		'ChromePicker': Chrome,
		TextContentEditModal
	},
	props: {
		componentName: {
			type: String,
			default: 'textFieldEditor'
		},
		tag: {
			type: String,
			default: 'p'
		},
		title: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'is-medium'
		},
		bold: {
			type: Boolean,
			default: false
		},
		id: {
			type: String,
			default: null
		},
		textData: {
			type: Object,
			default: function () {
				return {
					uiType: 'input',
					text: '',
					option: [
						/* {
							name: 'optionName',
							type: 'string, number, boolean, ',
							value: value
						} */
					],
					class: '', /* 'className1 className2', ... */
					style: {
						/* color: '#32320a', fontSize: '24px', padding: '20px 10px 20px 5px', margint: '0px auto 20px auto' */
					}
				}
			}
		}
	},
	data () {
		return {
			modal: ''
		}
	},
	computed: {
		getStyle () {
			if (this.textData.style) {
				return this.textData.style ? this.textData.style : {}
			} else {
				return {}
			}
		}
	},
	methods: {
		colorConvert (color) {
			var col
			if (typeof (color) === 'string') {
				col = tinycolor(color).toRgbString()
			} else if (typeof (color) === 'object') {
				col = tinycolor(color.rgba).toRgbString()
			}
			return col
		},
		colorConvertSet (e, obj, name) {
			if (!obj) return
			if (!name) return
			var tg = obj[name]
			var col
			if (tg) {
				col = tinycolor(e.rgba).toRgbString()
				obj[name] = col
			}
		},
		openModal (e) {
			// this.modal = 'textFieldModal'
			this.$buefy.modal.open(
				{
					parent: this,
					component: TextContentEditModal,
					trapFocus: true,
					props: { textData: this.textData },
					fullScreen: true
				}
			)
		}
	}
}
</script>

<style lang="scss"> // scoped
@import '@/css/variables.scss';
.icon { margin-left: 10px;}
.editStateWrap {
	padding: 20px;
	border-radius: 6px;
	border: 1px solid rgb(223, 223, 223);
	background-color: rgb(247, 247, 247);
	hr {
		border-bottom: 1px solid $c-gray-light2;
	}
	.buttons {
		border-top: 1px solid $c-gray-dark;
		padding: 20px 0 0;
		margin-top: 20px;
	}
}
.boardInputTxt {
	min-width: $mnWMobile;
}
.strech {
	align-content: stretch;
}
.popTitle { margin-top: 20px;}
.b-radio.radio {margin-right: 0;}
.boardComponentTextField {
	display: block;
	/* font-weight: bold; */
	.icon {
		display: none;
	}
	&.bold {
		font-weight: bold;
	}
	&:hover .icon {
		display: inline-block;
	}
}
.typeBoardTxt {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
	.typeBoardTxtTitle {
		display: block;
		letter-spacing: $lspace-short;
		& + .rowspan {
			margin-top: 16px;
		}
	}
	.rowspan {
		display: block;
		color: $c-gray-dark;
	}
	&.withHyphen {
		.rowspan {
			position: relative;
			padding-left: 10px;
			&::before {
				display: block;
				position: absolute;
				left: 0;
				content: '-';
			}
		}
	}
}

/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  //CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 650px) and (max-width: 767px) {
	//css
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
}
</style>
